import DOMPurify from 'dompurify';

/* eslint-disable */
export const safeHtmlDirective = (htmlElement: any, binding: any) => {
    // DOMPurify library to sanitize the HTML
    const purifiedHTML = DOMPurify.sanitize(binding.value);

    // Update the element's innerHTML with the purified HTML
    htmlElement.innerHTML = purifiedHTML;
};
/* eslint-enable */
